import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";

import {
  BTooltip,
  BButton,
  BCard,
  BTable,
  BCollapse,
  BFormGroup,
  BFormInput,
  VBModal,
  BModal,
  BFormSelect,
  BForm,
} from "bootstrap-vue";
export default {
  name: "Products",
  mixins: [mixins],
  components: {
    Loading,
    BTooltip,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
    BFormInput,
    BModal,
    BFormSelect,
    BForm,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      id: null,
      items: [],
      editModalItem: {},
      disabled: false,
      selectedStatus: null,
      serialInputs: [
        {
          serial: null,
          status: null,
        },
      ],
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "serial",
          label: "شماره سریال",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "delete",
          label: "حذف",
        },
        {
          key: "edit",
          label: "ویرایش",
        },
      ],
      statusOptions: [
        {
          value: "available",
          text: "موجود",
        },
        {
          value: "damaged",
          text: "معیوب",
        },
        {
          value: "draft",
          text: "پیش نویس",
        },
      ],
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    async loadData(id) {
      await this.$axios
        .get(`admin/product/${id}/serials`)
        .then((res) => {
          this.items = res.data.data.serials;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickHandler(flag) {
      if (flag == "+") {
        this.serialInputs.push({
          serial: null,
          status: null,
        });
      } else if (flag == "-" && this.serialInputs.length != 1) {
        this.serialInputs.pop();
      }
    },
    async submitHandler() {
      this.disabled = true;
      await this.$axios
        .post(`admin/product/${this.id}/serials`, {
          serials: [...this.serialInputs],
        })
        .then((res) => {
          res.data.data.newSerials.forEach((newSerial) => {
            this.items.data.push(newSerial);
          });
          this.$forceUpdate();
          this.$root.$emit("bv::hide::modal", "modal-add-serials");
          this.$root.notify(res.data.message, "success");
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    deleteItem(id) {
      window
        .swal({
          title: "آیتم حذف شود؟",
          text: "این عملیات غیر قابل بازگشت خواهد بود",
          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله حذف کن"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios
              .delete(`admin/product/1/serials/${id}`)
              .then((response) => {
                this.items.data = this.items.data.filter(
                  (item) => item.id != id
                );
                window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "باشه",
                });
              })
              .catch((error) => {
                window.swal({
                  title: "خطا",
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "باشه",
                });
              });
          }
        })
        .catch(() => {});
    },
    editItem(item) {
      if (item) {
        this.$root.$emit("bv::show::modal", "modal-edit-serials");
        this.editModalItem = item;
      } else {
      }
    },
    async editSubmitHandler() {
      this.disabled = true;
      let formData = new FormData();
      formData.append("_method", "put");
      formData.append("serial", this.editModalItem.serial);
      formData.append("status", this.editModalItem.status);
      await this.$axios
        .post(`admin/product/1/serials/${this.editModalItem.id}`, formData)
        .then((res) => {
          this.$root.$emit("bv::hide::modal", "modal-edit-serials");
          this.$root.notify(res.data.message, "success");
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
